import { RequestHelper } from "../Helpers/RequestHelper.js";

export class NPAApi {
    constructor(config) {
        this.config = config;
        this.sessionToken = null;
    }

    getURL() {
        return "https://npadsapi.sandbox.npauctions.com/api/";
    }

    login(successCallback, errorCallback) {
        let url = this.getURL() + "Login";
        let data = {
            password: "mNbVXkrUvkrfxyz!1",
            username: "Pixelmotion",
        };

        RequestHelper.ajax("POST", url, data, successCallback, errorCallback);
    }

    getVINDecode(data, successCallback, errorCallback) {
        let url = this.getURL() + "GetVINDecode";

        RequestHelper.ajax("POST", url, data, successCallback, errorCallback);
    }

    getTradeInValue(data, successCallback, errorCallback) {
        let url = this.getURL() + "GetValueGuide";

        RequestHelper.ajax("POST", url, data, successCallback, errorCallback);
    }

    authenticate(data, successCallback, errorCallback) {
        let url = this.getURL() + "Authenticate";
        RequestHelper.ajax("POST", url, data, successCallback, errorCallback);
    }
}
